export default {
  actions: {
    openMedia({ commit }, { heading = "", items = [], startIndex = 0 } = {}) {
      commit("setItems", { heading, items, startIndex });
      commit("toggle", true);
    },

    setComment({ commit }, comment = null) {
      commit("setComment", comment);
    },
    toggle({ commit }, isOpen = true) {
      commit("toggle", isOpen);
    },
  },
  mutations: {
    setComment(state, comment = null) {
      state.comment = comment;
      state.heading = "";
      state.items = [];
      state.startIndex = 0;
    },

    setItems(state, { heading = "", items = [], startIndex = 0 } = {}) {
      state.comment = null;
      state.heading = heading;
      state.items = items;
      state.startIndex = startIndex;
    },
    toggle(state, isOpen = true) {
      state.isOpen = isOpen;
    },
  },
  namespaced: true,
  state: {
    comment: null,
    heading: "",
    isOpen: false,
    items: [],
    startIndex: 0,
  },
};
